import { uuidToBase36 } from './base36';
import { v4 } from 'uuid';

export function getNewRfsId() {
  const uuid = v4();
  return `SGM_${uuidToBase36(uuid)}`;
}
